export enum MetaType {
  DEFAULT = 'DEFAULT',
  CREATE_LETTER_DEPARTMENT = 'CREATE_LETTER_DEPARTMENT',
  INFO_CHECK = 'INFO_CHECK',
  REDIRECT_LETTER = 'REDIRECT_LETTER',
  CREATE_ANSWER_DEPARTMENT = 'CREATE_ANSWER_DEPARTMENT',
  CARD = 'CARD',
  SIGN_UP = 'SIGN_UP',
}

export interface MetaDTO {
  title: string;
  departmentTitle: string;
  description: string;
  keywords: string;
}
